<template>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
            <CardProduct
                title="Agenda"
                description="Sistema de agendamiento de citas, con registro de pacientes"
                hasVideo="true"
                urlVideo="https://www.youtube.com/watch?v=vs5iXgEr5kk"
                hasSite="false"
                urlSite="/"
                :path="agenda"
                code="solo php"
            />
        </div>
        <div class="col">
            <CardProduct
                title="Inventario Medico"
                description="Registro de medicamentos, solicitud y entrega de los mismos"
                hasVideo="false"
                urlVideo="/"
                hasSite="false"
                urlSite="/"
                :path="imedico"
                code="solo php"
            />
        </div>
        <div class="col">
            <CardProduct
                title="Historia Clinica v.2.1"
                description="Registro de historias, evoluciones, recetsas, medicas, pacientes"
                hasVideo="false"
                urlVideo="/"
                hasSite="true"
                urlSite="http://sisofthistoria.epizy.com/sclinica/?i=1"
                :path="historia"
                code="codeigniter"
            />
        </div>
    </div>
</template>

<script>
    import CardProduct from './CardProduct.vue'
    import ImageAgenda from '../../public/img/ag.png'
    import ImageInventarioMedico from '../../public/img/im.png'
    import ImageHistoria from '../../public/img/sh.png'
    export default {
        components:{
            CardProduct
        },
        data: () => ({
            agenda: ImageAgenda,
            imedico: ImageInventarioMedico,
            historia: ImageHistoria
        })
    }
</script>